import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ForbbidenComponent } from './errors/forbidden.component';
import { PageNotFoundComponent } from './errors/pageNotFound.component';
import { InternalServerErrorComponent } from './errors/internalServerError.component';
import { BadRequestComponent } from './errors/badRequest.component';
import { RolesGuard } from '@core/roles/rolesGuard.service';
import { RoleTypeEnum } from '@shared/enums';
import { RootGuard } from '@core/root.guard';
import { CacheManagementGuard } from './cacheManagement/cacheManagementGuard.service';
import { ErrorsDemoGuard } from './errors/errorsDemo/errorsDemoGuard.service';
import { appInitializationGuard } from '@core/app-initialization/app-initialization.guard';
import { RemoteApplicationContainerComponent } from './remote-application';
import { isUrlOfStandardRemoteApplication } from './remote-application/helpers';
import { LoginLegacyGuard } from '@core/loginLegacy.guard';
import { paths } from '../assets/consts';

const routes: Routes = [
	{
		path: '',
		canActivate: [appInitializationGuard],
		children: [
			{
				path: '',
				redirectTo: paths.home,
				pathMatch: 'full',
			},
			{
				path: 'messages',
				loadChildren: () => import('./messages/messages.module').then(m => m.MessagesModule),
				canActivate: [RolesGuard],
				data: { allowAnonymous: true },
			},
			{
				path: 'notifications',
				loadChildren: () => import('./notifications/notifications.module').then(m => m.NotificationsModule),
			},
			{
				path: 'rx/viewer',
				redirectTo: 'viewer-wrapper/viewer',
				pathMatch: 'prefix',
			},
			{
				path: 'viewer-wrapper',
				loadChildren: () => import('./viewer/viewer.module').then(m => m.ViewerModule),
				canActivate: [RootGuard, RolesGuard],
				data: {
					expectedRoles: [RoleTypeEnum.Lab],
				},
			},
			{
				path: 'rx',
				loadChildren: () => import('./rx/rx.module').then(m => m.RxModule),
				canActivate: [RootGuard, RolesGuard],
				data: {
					expectedRoles: [RoleTypeEnum.Lab],
				},
			},
			{
				path: 'cache',
				loadChildren: () => import('./cacheManagement/cacheManagement.module').then(m => m.CacheManagementModule),
				canActivate: [RolesGuard],
				canLoad: [CacheManagementGuard],
				data: {
					expectedRoles: [RoleTypeEnum.Lab],
				},
			},
			{
				path: 'errorsdemo',
				loadChildren: () => import('./errors/errorsDemo/errorsDemo.module').then(m => m.ErrorsDemoModule),
				canActivate: [RolesGuard],
				canLoad: [ErrorsDemoGuard],
				data: {
					expectedRoles: [RoleTypeEnum.Lab],
				},
			},
			{
				path: 'labs',
				loadChildren: () => import('./labs/labs.module').then(m => m.LabsModule),
				canActivate: [RootGuard, RolesGuard],
				data: {
					expectedRoles: [RoleTypeEnum.Lab],
				},
			},
			{
				path: 'analytics',
				loadChildren: () => import('./shared/analytics/analytics.module').then(m => m.AnalyticsModule),
			},
			{
				path: 'mfe-wrapper',
				loadChildren: () => import('./mfe-wrapper/mfe-wrapper.module').then(m => m.MfeWrapperModule),
			},
			{
				matcher: isUrlOfStandardRemoteApplication(),
				component: RemoteApplicationContainerComponent,
			},
			{
				path: 'login-legacy',
				canActivate: [LoginLegacyGuard],
				loadChildren: () => import('./labs/labs.module').then(m => m.LabsModule),
			},
			{
				path: 'login',
				canActivate: [LoginLegacyGuard],
				loadChildren: () => import('./labs/labs.module').then(m => m.LabsModule),
			},
		],
	},
	{
		path: 'passwordpolicy',
		loadChildren: () => import('./passwordPolicy/passwordPolicy.module').then(m => m.PasswordPolicyModule),
	},
	{
		path: 'recoverpassword',
		loadChildren: () => import('./recoverPassword/recoverPassword.module').then(m => m.RecoverPasswordModule),
	},
	{ path: 'forbidden', component: ForbbidenComponent, pathMatch: 'full', data: { title: '403' } },
	{ path: 'pagenotfound', component: PageNotFoundComponent, pathMatch: 'full', data: { title: '404' } },
	{ path: 'internalservererror', component: InternalServerErrorComponent, pathMatch: 'full', data: { title: '500' } },
	{ path: 'badrequest', component: BadRequestComponent, pathMatch: 'full', data: { title: '400' } },
	{ path: '**', component: PageNotFoundComponent, data: { title: '404' } },
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {})],
	exports: [RouterModule],
})
export class AppRoutes {}
